var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner sop-template-form",
      staticStyle: { display: "flex", height: "100%" }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-card",
            {
              staticClass: "box-card form-column",
              staticStyle: { height: "100%", width: "840px", display: "flex" }
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  {
                    staticClass: "form-column",
                    staticStyle: { "margin-right": "30px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { width: "360px", "margin-right": "10px" },
                        attrs: {
                          disabled: _vm.readOnly,
                          "label-position": "left",
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "CargoMsg.Cargo_SetUpSopTemplateApplicationBusinessScenarios"
                              )
                            )
                          )
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Pricing.FeeIndex") } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    oninput:
                                      "value=value.replace(/[^\\d.]/g, '').replace(/\\.{2,}/g, '.').replace('.', '$#$').replace(/\\./g, '').replace('$#$', '.').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3').replace(/^\\./g, '')"
                                  },
                                  model: {
                                    value: _vm.form.serialNumber,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "serialNumber", $$v)
                                    },
                                    expression: "form.serialNumber"
                                  }
                                }),
                                _c(
                                  "el-checkbox",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    model: {
                                      value: _vm.form.displayOnTheHomepage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "displayOnTheHomepage",
                                          $$v
                                        )
                                      },
                                      expression: "form.displayOnTheHomepage"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_TheHomePageIsDisplayed"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SopTemplateName")
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.form.templateName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "templateName", $$v)
                                },
                                expression: "form.templateName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.containerLoadTypeName } },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                "static-options": _vm.fLclType,
                                placeholder: _vm.selectPlaceholder,
                                cache: false,
                                "default-multiple-value":
                                  _vm.containerLoadTypeArray,
                                filterable: "",
                                multiple: "",
                                clearable: "",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.containerLoadTypeArray = p.value
                                  _vm.changeTheSpellingType()
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm.form.lob === "IE"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.OperateType")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  ref: "operateType",
                                  attrs: {
                                    no: "operateType",
                                    filterable: "",
                                    clearable: "",
                                    multiple: "",
                                    "static-options": _vm.operateTypes,
                                    placeholder: _vm.selectPlaceholder,
                                    "default-multiple-value":
                                      _vm.operateTypeArray,
                                    "tag-name": _vm.isZh
                                      ? "chineseName"
                                      : "englishName",
                                    "tag-value": "code"
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.operateTypeArray = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_CustomJobType")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              ref: "customJobType",
                              attrs: {
                                no: "customJobType",
                                "static-options": _vm.customJobType,
                                filterable: "",
                                clearable: "",
                                multiple: "",
                                placeholder: _vm.selectPlaceholder,
                                "default-multiple-value":
                                  _vm.customJobTypeArray,
                                "tag-name": _vm.isZh ? "name" : "englishName",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.customJobTypeArray = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isSea || _vm.form.lob === "AI",
                                expression: "isSea || form.lob === 'AI'"
                              }
                            ],
                            attrs: {
                              label:
                                _vm.form.lob === "AI"
                                  ? _vm.$t("SeaExport.TransportationClause")
                                  : _vm.$t("SeaExport.MBLTransportationClause")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_ShippingTerm,
                                filterable: "",
                                placeholder: _vm.selectPlaceholder,
                                multiple: "",
                                clearable: "",
                                "default-value": _vm.form.freightTerm,
                                "default-multiple-value": _vm.freightTermArray
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.freightTermArray = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isSea,
                                expression: "isSea"
                              }
                            ],
                            attrs: {
                              label: _vm.$t("SeaExport.HBLTransportationClause")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_ShippingTerm,
                                filterable: "",
                                clearable: "",
                                placeholder: _vm.selectPlaceholder,
                                multiple: "",
                                "default-multiple-value":
                                  _vm.freightTermHBLArray
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.freightTermHBLArray = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "cargoType",
                                clearable: "",
                                placeholder: _vm.selectPlaceholder,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_CargoType,
                                "method-params": _vm.cargoTypeMethodParams,
                                filterable: "",
                                multiple: "",
                                "default-multiple-value": _vm.cargoTypeArray,
                                "callback-params":
                                  _vm.form.lob === "SI"
                                    ? { key: "cargoType" }
                                    : null
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.cargoTypeArray = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm.form.lob === "SE"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: { label: _vm.$t("CargoMsg.Cargo_IsSoc") }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      no: "soc",
                                      clearable: "",
                                      placeholder: _vm.selectPlaceholder,
                                      size: "mini"
                                    },
                                    model: {
                                      value: _vm.form.soc,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "soc", $$v)
                                      },
                                      expression: "form.soc"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Message.Yes"),
                                        value: true
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Message.No"),
                                        value: false
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.lob !== "IE"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.LocalService")
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: _vm.notLocalService,
                                      callback: function($$v) {
                                        _vm.notLocalService = $$v
                                      },
                                      expression: "notLocalService"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.NotLocalService")
                                      )
                                    )
                                  ]
                                ),
                                _c("cargo-advance-select", {
                                  attrs: {
                                    disabled: _vm.notLocalService,
                                    filterable: "",
                                    clearable: "",
                                    placeholder: _vm.selectPlaceholder,
                                    multiple: "",
                                    "clear-not-match": "",
                                    "tag-value": "code",
                                    "static-options": _vm.localServices,
                                    "default-multiple-value":
                                      _vm.localServiceArray
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.localServiceArray = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.lob === "SE"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_DestinationAgent"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: _vm.notDestinationAgent,
                                      callback: function($$v) {
                                        _vm.notDestinationAgent = $$v
                                      },
                                      expression: "notDestinationAgent"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_None") +
                                          _vm.$t(
                                            "CargoMsg.Cargo_DestinationAgent"
                                          )
                                      )
                                    )
                                  ]
                                ),
                                _c("cargo-advance-select", {
                                  attrs: {
                                    disabled: _vm.notDestinationAgent,
                                    filterable: "",
                                    clearable: "",
                                    placeholder: _vm.selectPlaceholder,
                                    multiple: "",
                                    "clear-not-match": "",
                                    "tag-value": "code",
                                    "static-options": _vm.destinationAgents,
                                    "default-multiple-value":
                                      _vm.destinationAgentArray
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.destinationAgentArray = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.lob === "SI"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaImport.ChangeOrders")
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      no: "trans",
                                      clearable: "",
                                      placeholder: _vm.selectPlaceholder,
                                      size: "mini"
                                    },
                                    model: {
                                      value: _vm.form.trans,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "trans", $$v)
                                      },
                                      expression: "form.trans"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("CargoMsg.Need"),
                                        value: true
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("CargoMsg.NoNeed"),
                                        value: false
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.lob === "AE"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SeaExport.CustomsDeclarationType"
                                  )
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "customsClaim",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .local_cache_AirExportConstants$CUSTOM_CLAIMS2,
                                    filterable: "",
                                    clearable: "",
                                    multiple: "",
                                    "default-multiple-value":
                                      _vm.customsClaimArray,
                                    placeholder: _vm.selectPlaceholder
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.customsClaimArray = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.lob !== "AE"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.CustomsDeclaration")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "customs",
                                    "static-options": _vm.needList,
                                    filterable: "",
                                    clearable: "",
                                    placeholder: _vm.selectPlaceholder,
                                    "tag-value": "code",
                                    "default-value": _vm.form.customs
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.customs = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.lob === "AE"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "AirExport.CustomsDeclarationMethod"
                                  )
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "customsMethod",
                                    filterable: "",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .local_cache_AirExportConstants$CUSTOM_CLAIMS,
                                    "default-multiple-value":
                                      _vm.customsMethodArray,
                                    "tag-name": _vm.isZh
                                      ? "chineseName"
                                      : "englishName",
                                    fields: ["chineseName"],
                                    placeholder: _vm.selectPlaceholder,
                                    multiple: ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.customsMethodArray = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.lob === "AE"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.BookingProperty")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "bookingTerm",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .local_cache_BookingTerm,
                                    filterable: "",
                                    clearable: "",
                                    multiple: "",
                                    "default-multiple-value":
                                      _vm.bookingTermArray,
                                    placeholder: _vm.selectPlaceholder,
                                    fields: ["chineseName"]
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.bookingTermArray = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.lob === "SE",
                                expression: "form.lob === 'SE'"
                              }
                            ],
                            attrs: {
                              label: _vm.$t("SeaExport.Anti_terrorismShipping")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "customs",
                                "static-options": _vm.needList,
                                filterable: "",
                                "tag-value": "code",
                                placeholder: _vm.selectPlaceholder,
                                clearable: "",
                                "default-value": _vm.form.ams
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.ams = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.lob === "SE",
                                expression: "form.lob === 'SE'"
                              }
                            ],
                            attrs: {
                              label: _vm.$t("SeaExport.SolicitationType")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  no: "cargoSource",
                                  clearable: "",
                                  placeholder: _vm.selectPlaceholder,
                                  size: "mini"
                                },
                                model: {
                                  value: _vm.form.cargoSource,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cargoSource", $$v)
                                  },
                                  expression: "form.cargoSource"
                                }
                              },
                              _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm.isZh
                                      ? item.chineseName
                                      : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ApplicationBranch")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Office,
                                filterable: "",
                                multiple: "",
                                placeholder: _vm.selectPlaceholder,
                                clearable: "",
                                "default-multiple-value": _vm.officeArray
                              },
                              on: { parentCallBack: _vm.onOfficeChange }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_ApplicationDepartment"
                              )
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                filterable: "",
                                multiple: "",
                                placeholder: _vm.selectPlaceholder,
                                clearable: "",
                                "static-options": _vm.departmentList,
                                "tag-value": "departmentId",
                                "default-multiple-value": _vm.departmentArray
                              },
                              on: { parentCallBack: _vm.onDepartmentChange }
                            })
                          ],
                          1
                        ),
                        _vm.form.lob === "SE"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_IsTransfer")
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      no: "transfering",
                                      clearable: "",
                                      placeholder: _vm.selectPlaceholder,
                                      size: "mini"
                                    },
                                    model: {
                                      value: _vm.form.transfering,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "transfering", $$v)
                                      },
                                      expression: "form.transfering"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Message.Yes"),
                                        value: true
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Message.No"),
                                        value: false
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.lob === "SE",
                                expression: "form.lob === 'SE'"
                              }
                            ],
                            staticStyle: {
                              width: "360px",
                              "margin-right": "10px"
                            },
                            attrs: {
                              "label-position": "left",
                              "label-width": "100px"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_MoreBusinessConditions"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.showMoreConditionDialog.visible = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_MoreConditionsOptions"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: 3 },
                              model: {
                                value: _vm.form.remark,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remark", $$v)
                                },
                                expression: "form.remark"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "20px",
                              "margin-bottom": "20px"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.DropThisConditionForGoods"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "form-column" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { width: "420px" },
                        attrs: {
                          disabled: _vm.readOnly,
                          "label-position": "right",
                          "label-width": "110px"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "CargoMsg.Cargo_QuicklySelectBusinessNodes"
                              )
                            )
                          )
                        ]),
                        _c(
                          "el-checkbox-group",
                          {
                            staticClass: "checkboxGroup",
                            model: {
                              value: _vm.form.chooseNodeCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "chooseNodeCode", $$v)
                              },
                              expression: "form.chooseNodeCode"
                            }
                          },
                          [
                            _c(
                              "el-row",
                              _vm._l(_vm.platformTracking, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "el-col",
                                  {
                                    key: index,
                                    staticStyle: { "margin-top": "2px" },
                                    attrs: { span: _vm.isZh ? 6 : 8 }
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          label: item.code,
                                          title:
                                            item.level +
                                            "." +
                                            (_vm.isZh
                                              ? item.codeCname
                                              : item.codeEname)
                                        },
                                        on: {
                                          change: function(checked) {
                                            return _vm.changeNodeCode(
                                              checked,
                                              item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.level +
                                              "." +
                                              (_vm.isZh
                                                ? item.codeCname
                                                : item.codeEname)
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        false
                          ? _c("div", [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.form.lob === "SE",
                                      expression: "form.lob === 'SE'"
                                    }
                                  ],
                                  staticClass: "title",
                                  staticStyle: { "margin-top": "20px" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_QuicklyConfigureDataServices"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.form.lob === "SE",
                                    expression: "form.lob === 'SE'"
                                  }
                                ],
                                staticClass: "el-icon-info",
                                staticStyle: {
                                  color: "#1F75D5",
                                  "font-size": "16px",
                                  "margin-left": "5px"
                                },
                                on: { click: _vm.learnMore }
                              }),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.form.lob === "SE",
                                      expression: "form.lob === 'SE'"
                                    }
                                  ],
                                  staticStyle: { display: "flex" }
                                },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.form.chooseNodeStatusCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "chooseNodeStatusCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.chooseNodeStatusCode"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ShipPlanningAtThePortOfDeparture"
                                            )
                                          }
                                        },
                                        _vm._l(_vm.shipPlannings, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: index,
                                              attrs: { label: item.code },
                                              on: {
                                                change: function(checked) {
                                                  return _vm.changeStatusCode(
                                                    checked,
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isZh
                                                    ? item.fieldName
                                                    : item.fieldEname
                                                )
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ContainerTracking"
                                            )
                                          }
                                        },
                                        _vm._l(_vm.containerTracking, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: index,
                                              attrs: { label: item.code },
                                              on: {
                                                change: function(checked) {
                                                  return _vm.changeStatusCode(
                                                    checked,
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isZh
                                                    ? item.fieldName
                                                    : item.fieldEname
                                                )
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ShipDynamicsAtThePortOfDestination"
                                            )
                                          }
                                        },
                                        _vm._l(_vm.shipDynamics, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: index,
                                              attrs: { label: item.code },
                                              on: {
                                                change: function(checked) {
                                                  return _vm.changeStatusCode(
                                                    checked,
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isZh
                                                    ? item.fieldName
                                                    : item.fieldEname
                                                )
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: { "margin-top": "20px" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_SetTheNotificationRecipients"
                                )
                              )
                            )
                          ]
                        ),
                        !!_vm.form.innerConfig
                          ? [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.form.innerConfig.post,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.innerConfig,
                                        "post",
                                        $$v
                                      )
                                    },
                                    expression: "form.innerConfig.post"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_DesignatedPost")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "15px" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value: _vm.form.innerConfig.sales,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "sales",
                                            $$v
                                          )
                                        },
                                        expression: "form.innerConfig.sales"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Sales"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value: _vm.form.innerConfig.op,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "op",
                                            $$v
                                          )
                                        },
                                        expression: "form.innerConfig.op"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_Operation")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value: _vm.form.innerConfig.csr,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "csr",
                                            $$v
                                          )
                                        },
                                        expression: "form.innerConfig.csr"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_CustomerService"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value: _vm.form.innerConfig.overseaOp,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "overseaOp",
                                            $$v
                                          )
                                        },
                                        expression: "form.innerConfig.overseaOp"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.OverseaCustomerService"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value: _vm.form.innerConfig.dc,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "dc",
                                            $$v
                                          )
                                        },
                                        expression: "form.innerConfig.dc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Documents"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value: _vm.form.innerConfig.planner,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "planner",
                                            $$v
                                          )
                                        },
                                        expression: "form.innerConfig.planner"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.AirlinePerson2")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value: _vm.form.innerConfig.cargoSales,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "cargoSales",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.innerConfig.cargoSales"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.SalesOfGoods"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value: _vm.form.innerConfig.siteOp,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "siteOp",
                                            $$v
                                          )
                                        },
                                        expression: "form.innerConfig.siteOp"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.FieldOperation")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value:
                                          _vm.form.innerConfig
                                            .userDefinedRoleId1,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "userDefinedRoleId1",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.innerConfig.userDefinedRoleId1"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole1"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value:
                                          _vm.form.innerConfig
                                            .userDefinedRoleId2,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "userDefinedRoleId2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.innerConfig.userDefinedRoleId2"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole2"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value:
                                          _vm.form.innerConfig
                                            .userDefinedRoleId3,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "userDefinedRoleId3",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.innerConfig.userDefinedRoleId3"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole3"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value:
                                          _vm.form.innerConfig
                                            .userDefinedRoleId4,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "userDefinedRoleId4",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.innerConfig.userDefinedRoleId4"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole4"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value:
                                          _vm.form.innerConfig
                                            .userDefinedRoleId5,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "userDefinedRoleId5",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.innerConfig.userDefinedRoleId5"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole5"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value:
                                          _vm.form.innerConfig
                                            .userDefinedRoleId6,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "userDefinedRoleId6",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.innerConfig.userDefinedRoleId6"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole6"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value:
                                          _vm.form.innerConfig
                                            .userDefinedRoleId7,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "userDefinedRoleId7",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.innerConfig.userDefinedRoleId7"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole7"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.form.innerConfig.post
                                      },
                                      model: {
                                        value:
                                          _vm.form.innerConfig
                                            .userDefinedRoleId8,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.innerConfig,
                                            "userDefinedRoleId8",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.innerConfig.userDefinedRoleId8"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole8"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    change: function($event) {
                                      _vm.form.innerConfig.userList = []
                                    }
                                  },
                                  model: {
                                    value: _vm.form.innerConfig.personnel,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.innerConfig,
                                        "personnel",
                                        $$v
                                      )
                                    },
                                    expression: "form.innerConfig.personnel"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_DesignatedPersonnel"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                staticStyle: { width: "205px" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_User,
                                  fields: ["chineseName"],
                                  disabled: !_vm.form.innerConfig.personnel,
                                  placeholder: _vm.selectPlaceholder,
                                  "callback-params": { key: "userList" },
                                  "callback-method-type": "value",
                                  "tag-value": "userId",
                                  "tag-name": "chineseName",
                                  "filter-tag-names": ["chineseName"],
                                  "method-params": {
                                    pageSize: 1000000,
                                    active: true,
                                    hasRole: true
                                  },
                                  "default-multiple-value":
                                    _vm.form.innerConfig.userList,
                                  multiple: "",
                                  filterable: "",
                                  "options-width": "230px"
                                },
                                on: {
                                  parentCallBack:
                                    _vm.getInnerConfigValueFromChild
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "title",
                                  staticStyle: {
                                    "margin-top": "20px",
                                    width: "100%"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_ReminderMethod")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.form.innerConfig.email,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.innerConfig,
                                        "email",
                                        $$v
                                      )
                                    },
                                    expression: "form.innerConfig.email"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Viewer.email")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.form.innerConfig.weChat,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.innerConfig,
                                        "weChat",
                                        $$v
                                      )
                                    },
                                    expression: "form.innerConfig.weChat"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Wechat"))
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.form.innerConfig.bellMsg,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.innerConfig,
                                        "bellMsg",
                                        $$v
                                      )
                                    },
                                    expression: "form.innerConfig.bellMsg"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Message.Message")))]
                              )
                            ]
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: { "margin-top": "20px", width: "100%" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_TemplateNodeWorkTaskSetting"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.form.workTaskEnable,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "workTaskEnable", $$v)
                              },
                              expression: "form.workTaskEnable"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_WorkTaskEnable"))
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: { "margin-top": "20px", width: "100%" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SystemMaintenance.SOPRestrictionsForBusinessDocuments"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              disabled:
                                !_vm.officeArray || _vm.officeArray.length === 0
                            },
                            model: {
                              value: _vm.form.onlyApplyBranchAndHq,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "onlyApplyBranchAndHq", $$v)
                              },
                              expression: "form.onlyApplyBranchAndHq"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SystemMaintenance.OnlyForTheBranchTemplate"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              disabled:
                                !_vm.departmentArray ||
                                _vm.departmentArray.length === 0
                            },
                            model: {
                              value: _vm.form.onlyApplyDepartmentAndHq,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "onlyApplyDepartmentAndHq",
                                  $$v
                                )
                              },
                              expression: "form.onlyApplyDepartmentAndHq"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SystemMaintenance.OnlyOperationDepartmentAndTemplate"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm.showMoreConditionDialog.visible
        ? _c("cargo-multi-condition-tab", {
            attrs: {
              visible: _vm.showMoreConditionDialog.visible,
              title: _vm.$t("CargoMsg.Cargo_BusinessConditionsOptions"),
              "config-module": "71040402",
              "detail-value": _vm.form.moreConditions,
              readonly: _vm.readOnly
            },
            on: {
              change: _vm.changeMoreConditions,
              close: function($event) {
                _vm.showMoreConditionDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }